import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";

import DropdownContent from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/DropdownContent";
import { StyledDropdownSearch } from "app/pages/workspace/sales/components/custom-dropdown/DropdownSearch/styles";

import type { IStyledBaseDropdownButtonWrapProps } from "./types";

export const StyledScrollableBody = styled.div<{ height: number }>`
    flex-grow: 1;
    overflow-y: scroll;
    ${({ height }) => css`
        max-height: ${height}px;
    `};
`;

export const StyledDropdownBody = styled(DropdownContent)`
    position: absolute;
    top: -4px;
    left: 0;
    z-index: 11;
    width: 100%;
    min-width: 240px;
    background-color: ${colorsPalettes.carbon["0"]};
    border: 1px solid ${colorsPalettes.carbon["50"]};
    border-radius: 4px;
    box-shadow: 0 1px 5px ${rgba(colorsPalettes.carbon["500"], 0.12)};

    &.--closed {
        display: none;
    }

    ${StyledDropdownSearch} {
        ${SWReactIcons} {
            margin-right: 8px;
        }

        & .input-container input {
            box-sizing: content-box;
            padding: 18px 5px 18px 0;
            height: 20px;
        }
    }
`;

export const StyledDropdownContainer = styled.div`
    position: relative;
`;

export const StyledBaseDropdownButtonWrap = styled.div.attrs<
    Partial<IStyledBaseDropdownButtonWrapProps>,
    IStyledBaseDropdownButtonWrapProps
>(({ buttonTextColor = colorsPalettes.carbon["200"], disabled = false }) => ({
    buttonTextColor,
    disabled,
}))`
    width: 100%;

    & .DropdownButton {
        background-color: ${colorsPalettes.carbon["0"]};
        border-color: ${colorsPalettes.midnight["50"]};
        box-sizing: border-box;
        color: ${(props) => props.buttonTextColor};
        height: 40px;

        ${({ disabled }) =>
            disabled &&
            css`
                background-color: ${colorsPalettes.bluegrey[200]};
            `}
        .DropdownButton--triangle {
            color: ${({ disabled }) => (disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon["400"])};
        }
    }

    & .DropdownButton:active {
        background-color: ${colorsPalettes.carbon["0"]};
        color: ${(props) => props.buttonTextColor};

        .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;

export const StyledCustomLabelFragment = styled.span<{ highlighted: boolean }>`
    ${(p) =>
        p.highlighted &&
        css`
            background-color: ${colorsPalettes.blue[100]};
        `}
    white-space: initial;
`;

export const StyledCustomDropdownItem = styled(EllipsisDropdownItem)`
    grid-template-columns: auto 0 24px;
`;
